import { useState } from 'react';

const useSpeedDial = () => {
  const [open, setOpen] = useState(false);

  return { open, setOpen };
};

export default useSpeedDial;
